import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthSessionUtil } from "../utils/auth-session.util";


export const noAuthGuard: CanActivateFn = () => {
  const authSession = inject(AuthSessionUtil);
  const router = inject(Router);

  if (!authSession.isLoggedIn()) {
    return true;
  }

  return router.createUrlTree(['/']);
};